export default __webpack_public_path__ + "static/media/etherium_gif.5844d350.gif";